import clsx from "clsx";
import { memo } from "react";
import "./CodeCell.scss";

export type CodeCellProps = {
  value: string;
  className?: string;
};

export const CodeCell = memo(({ value, className }: CodeCellProps) => {
  if (!value) {
    return null;
  }

  return <span className={clsx("tableCodeCell", className)}>{value}</span>;
});

CodeCell.displayName = "CodeCell";
